import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { Deactivate2FaRequest } from './2fa.types'

const deactivate2Fa = async (payload: Deactivate2FaRequest): Promise<void> => {
  await apiClient.post('/v1/administration/user/2fa/deactivate', payload)
}

export const useDeactivate2Fa = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (payload: Deactivate2FaRequest) => deactivate2Fa(payload),
    meta: {
      // 'user-account-context' carries userAccountInformation.has2FaEnabled,
      // which gates the account-wide 2FA enforcement modal
      invalidatesQuery: ['user-2fa-status', 'user-account-context'],
      ...feedback,
    },
  })
}
